module.exports = __webpack_public_path__ + "img/newCand-view-icon.f5ef480a.svg";